import React from "react";

interface RapidLogoProps {
    className?: string;
}

const RapidLogo: React.FC<RapidLogoProps> = ({ className = "" }) => {
    return (
        <div
            className={`relative flex flex-row items-center justify-center gap-1 hover:opacity-80 ${className}`}
        >
            <img
                src="/images/logo.png"
                alt="Roboflow Rapid"
                className="w-20 flex-none opacity-100 transition-opacity duration-100"
            />
            <span className="mt-1 text-sm font-bold text-brand transition-opacity duration-100 group-hover:opacity-0">
                RAPID
            </span>
            <img
                src="/images/running_lenny_outline.gif"
                alt="Running Raccoon"
                className="absolute left-20 top-0 ml-1 mt-1 h-4 w-10 opacity-0 transition-opacity duration-100 group-hover:opacity-100"
            />
        </div>
    );
};

export default RapidLogo;
